import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-familia-section relative py-10 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-250">
      <div className="absolute inset-0 bg-gradient-to-r from-familia-bg/60 to-familia-section opacity-60 pointer-events-none" data-id="element-251" />
      <div className="relative z-10 max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-252">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-6 md:mb-8 leading-tight" data-id="element-253">
          ¿Cuánto tiempo más vas a seguir buscando actividades sueltas sin tener
          un sistema claro para acompañarlo?
        </h2>
        <div className="space-y-2 text-familia-gray text-[15px] md:text-xl max-w-2xl mx-auto" data-id="element-254">
          <p data-id="element-255">
            El problema no es falta de amor ni de voluntad. El problema es que
            nadie te dio un sistema claro para hacerlo.
          </p>
          <p className="text-white font-bold" data-id="element-256">
            Eso es exactamente lo que cambia con Vitalidad 360™.
          </p>
        </div>
      </div>
    </section>;
};